import { CreateDecisions } from '../../types';

export const createNavigationListDecisions: CreateDecisions = ({ decisions }) => ({
    backgroundColor: {
        value: decisions.backgroundColor.onSemanticBackground.light.basic,
        state: {
            hover: {
                value: decisions.backgroundColor.body.basic,
            },
            active: {
                value: decisions.backgroundColor.semanticSubtle.basic,
            },
        },
    },
    borderColor: {
        value: decisions.borderColor.divider.basic,
        state: {
            focus: {
                value: decisions.interactive.primary.default,
            },
        },
    },
    color: {
        value: decisions.textColor.font.basic.default,
    },
});
